import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { DEFAULT_ICON_PATH, ICON_PATHS } from './icon-paths';

@Component({
  standalone: true,
  selector: 'app-icon',
  template: `
    <svg
      class="app-icon"
      [class]="className"
      [attr.width]="size"
      [attr.height]="size"
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
    >
      <path [attr.d]="path" fill="currentColor" />
    </svg>
  `,
  styles: [
    `
      :host {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        line-height: 0;
        vertical-align: middle;
      }

      .app-icon {
        display: block;
        width: 1em;
        height: 1em;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppIconComponent {
  @Input({ required: true }) name!: string;
  @Input() className = '';
  @Input() size: number | null = null;

  get path(): string {
    return ICON_PATHS[this.name] ?? DEFAULT_ICON_PATH;
  }
}
